import Vue from 'vue'
import Vuex from 'vuex'
import { actions, getters, mutations } from './modules/base'
import { stages } from './modules/base/enums/room-stages'

Vue.use(Vuex);

const initialState = {
  token: '',
  
  stage: stages.TO_CALL,
  status: 'loading',
  room: { id: '', name: '' },
  
  error: null
};

const store = new Vuex.Store({
  state: initialState,
  actions,
  mutations,
  getters
});

export { store }